import { render } from "./quote-breakdown.vue?vue&type=template&id=738c13e6&scoped=true"
import script from "./quote-breakdown.vue?vue&type=script&lang=js"
export * from "./quote-breakdown.vue?vue&type=script&lang=js"

import "./quote-breakdown.vue?vue&type=style&index=0&id=738c13e6&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738c13e6"]])

export default __exports__